// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__2bkNv","title":"card_title__3nUA8","inActive":"card_inActive__3fOji"};